import { AbstractType, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { CommonFunctionService, UserMerchantData } from './Common/common-function.service';
import { DataService } from './data.service';
import { VposMerchantSettingsAppView } from 'src/app/models/vpos-merchant-settings-app-view';
import { LoginUserModel } from 'src/app/models/login-user-model';

import { JwtHelperService } from '@auth0/angular-jwt';
import { catchError, map } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PayoutService {
  token;
  headers: any;
  token1
  headers1: any;
  constructor(private service: DataService, private http: HttpClient, private common: CommonFunctionService) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    let loggedUsername = this.common.getUserName();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    // const helper = new JwtHelperService();
    // if (localStorage.getItem('VirtualPOSToken') != null) {
    //   this.token=helper.decodeToken(localStorage.getItem('VirtualPOSToken'));
    //   this.headers = new HttpHeaders(). 
    //   set('Authorization', 'Bearer '+this.token);
    //   }
  }
  newpayout(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.newPayOuturl, data, { headers: this.headers });
  }


  GetCustomerkeyIDDetail(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetCustomerkeyIDDetail + "?CustomerId=" + data.Id + "&Merchantkeyid=" + data.merchantKeyId+ "&LoginUserId="+merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));

  }
  GetCustomerAccountIDDetail(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetCustomerAccountIDDetail + "?CustomerId=" + data.Id + "&Merchantkeyid=" + data.merchantKeyId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));

  }

  GetCustomerAccountkeyIDDetail(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetCustomerAccountkeyIDDetail + "?CustomerId=" + data.Id + "&Merchantkeyid=" + data.merchantKeyId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  NewVirtualinfo(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.newVirtualinfo, data, { headers: this.headers });
  }
  ViewPayOutContactDetails(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.viewPayoutContactDetails + "?Id=" + data + "&MerchantKeyId=" + MerchantKeyId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  ViewCustomerVirtualAccounDetails(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.ViewCustomerVirtualAccounDetails + "?Id=" + data + "&MerchantKeyId=" + MerchantKeyId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  ViewPayOutTransactionDetails(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.ViewPayOutTransactionDetailsurl +
        "?Id=" +
        data +
        "&MerchantKeyId=" +
        MerchantKeyId
        + "&LoginUserId=" + merchantdata.UserId
        , { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));
  }
  ViewPayOutLedgerDetails(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.ViewPayOutLedgerDetailsurl +
        "?Id=" +
        data +
        "&MerchantKeyId=" +
        MerchantKeyId
        + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));
  }

  ViewAccountBalance(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.ViewAccountBalanceurl +
        "?MerchantKeyId=" +
        MerchantKeyId
        + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));
  }

  GetAccountBalance(MerchantKeyId, ProcessorId) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http
      .get<any>(
        environment.GetAccountBalance +
        "?MerchantKeyId=" +
        MerchantKeyId
        +
        "&ProcessorId=" +
        ProcessorId
        + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));
  }
  Editpayout(data) {
    this.GetHeaderdetails();
    return this.http.put(
      environment.updatePayOutContactUrl + "?id=" + data.Id,
      data
      , { headers: this.headers });
  }
  newBeneficiarie(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.newBeneficiarieurl, data, { headers: this.headers });
  }
  ViewPayOutBeneficiarie(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.ViewPayOutBeneficiarieurl +
        "?Id=" +
        data +
        "&MerchantKeyId=" +
        MerchantKeyId
        + "&LoginUserId=" + merchantdata.UserId
        , { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));
  }


  ViewBeneficiarieDetails(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.viewBeneficiarieDetails +
        "?Id=" +
        data +
        "&MerchantKeyId=" +
        MerchantKeyId
        + "&LoginUserId=" + merchantdata.UserId
        , { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));
  }

  Deletepayout(data) {
    this.GetHeaderdetails();
    return this.http.put(
      environment.DeletePayOutContactUrl + "?id=" + data.Id,
      data, { headers: this.headers }
    );
  }
  deleteBeneficiarie(data) {
    this.GetHeaderdetails();
    return this.http.put(
      environment.DeleteBeneficiarieUrl + "?id=" + data.Id,
      data, { headers: this.headers }
    );
  }

  DeleteVirtualinfo(data) {
    this.GetHeaderdetails();
    return this.http.put(
      environment.DeleteVirtualinfoUrl + "?id=" + data.Id,
      data, { headers: this.headers }
    );
  }

  EditVirtualinfo(data) {
    this.GetHeaderdetails();
    return this.http.put(
      environment.updateVirtualinfoUrl + "?id=" + data.Id,
      data
      , { headers: this.headers });
  }
  updateBeneficiarie(data) {
    this.GetHeaderdetails();
    return this.http.put(environment.UpdateBeneficiarieurl, data, { headers: this.headers });
  }

  newtransactiondetail(data) {


    this.GetHeaderdetails();
    return this.http.post<any>(environment.PayOutTransurl, data, { headers: this.headers })





  }

  getTransactionFee(merchantKeyId, amount) {
    let loggedUsername = this.common.getUserName()
    this.token1 = merchantKeyId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + merchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.get<any>(environment.PayOutGetTransactionFee + "?merchantkeyid=" + merchantKeyId + "&amount=" + amount, { headers: this.headers })
  }

  VerifyBeneficiary(data) {


    // let loggedUsername =this.common.getUserName()
    // this.token1 =data.CustomerId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" +'IT'+":"+ data.MerchantKeyId;
    // this.headers = new HttpHeaders().
    // set('Authorization', 'basic ' + btoa(this.token1));
    this.GetHeaderdetails();
    return this.http.post<any>(environment.VerifyBeneficiaryurl, data, { headers: this.headers })



  }



  ViewPayOutBatchView(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.ViewPayOutBatchDetailsView +
        "?Id=" +
        data +
        "&MerchantKeyId=" +
        MerchantKeyId
        + "&LoginUserId="+merchantdata.UserId
, { headers: this.headers })
.pipe(map(response => response),catchError(this.common.handleError));
  }
  ViewPayOutBatchDetails
    (data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.ViewPayOutBatchDetailsDetails +
        "?Id=" +
        data +
        "&MerchantKeyId=" +
        MerchantKeyId
        + "&LoginUserId="+merchantdata.UserId
, { headers: this.headers })
.pipe(map(response => response),catchError(this.common.handleError));
  }
  ViewPayOutBatchViewdetails(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.ViewPayOutBatchDetailView +
        "?Id=" +
        data +
        "&MerchantKeyId=" +
        MerchantKeyId
        + "&LoginUserId="+merchantdata.UserId
, { headers: this.headers })
.pipe(map(response => response),catchError(this.common.handleError));
  }

  CancellSchedulePayment(data, MerchantKeyId) {

    let loggedUsername = this.common.getUserName()
    this.token1 = data + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + MerchantKeyId;
    const headers = new HttpHeaders(). 
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.get<any>(environment.CancellSchedulePaymenturl + "?Id=" + data + "&MerchantKeyId=" + MerchantKeyId, { headers: this.headers })

  }

  ViewPayOutBeneficiarieList(data, MerchantKeyId) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http
      .get<any>(
        environment.ViewPayOutBeneficiarieListUrl +
        "?MerchantKeyId=" +
        MerchantKeyId
        + "&CustomerKeyId=" +
        data
        + "&LoginUserId="+merchantdata.UserId
, { headers: this.headers })
.pipe(map(response => response),catchError(this.common.handleError));
  }


  AddVirtualAccountBalance(data) {

    let loggedUsername = this.common.getUserName()
    this.token1 = data.ProcessorId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post<any>(environment.AddAccountBalanceurl, data, { headers: this.headers });

  }


  FileUpload(data, merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.post(environment.PayOutBulkurl + '?merchantKeyId=' + merchantKeyId+ "&LoginUserId="+merchantdata.UserId, data
    , { headers: this.headers });
  }


  BulkUploadFilesview(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();

    return this.http
      .get<any>(
        environment.ViewBulkUploadFilesUrl +
        "?MerchantKeyId=" +
        MerchantKeyId
        + "&Id=" +
        data
        + "&LoginUserId="+merchantdata.UserId
, { headers: this.headers })
.pipe(map(response => response),catchError(this.common.handleError));
  }

  GetPayOutBulkUploadFilesList(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.GetBulkUploadFileListUrl +
        "?MerchantKeyId=" +
        MerchantKeyId
        + "&Id=" +
        data
        + "&LoginUserId="+merchantdata.UserId
, { headers: this.headers })
.pipe(map(response => response),catchError(this.common.handleError));
  }
  BulkUploadFilesviewdetail(data, MerchantKeyId) {
    this.GetHeaderdetails();
    return this.http
      .get<any>(
        environment.GetBulkUploadFiledetailsurl +
        "?MerchantKeyId=" +
        MerchantKeyId
        + "&Id=" +
        data
        , { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));
  }

  // GetBeneficiarieDetails(data) {
  //   return this.http.get<any>(environment.GetBeneficiariesViewDetailsurl,data)
  //   .map(response => response);


  // }

  ViewPayOutNameDetails(data) {
    // return this.http.get<any>(environment.ViewPayOutNameDetails,data)
    // .map(response => response);
    let loggedUsername = this.common.getUserName()
    this.token1 = data.CustomerId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    // return this.service.create(environment.ViewPayOutNameDetails, data, { headers:this.headers });
    return this.http.post(environment.ViewPayOutNameDetails, data, { headers: this.headers })



  }
  GetBeneficiarieBankDetails(data) {

    let loggedUsername = this.common.getUserName()
    this.token1 = data.CustomerId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post(environment.GetBeneficiarieBankDetailsurl, data, { headers: this.headers });
  }
  checkAccountdetails(data) {
    let loggedUsername = this.common.getUserName()
    this.token1 = data.CustomerId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post(environment.checkpayoutAccountdetailsurl, data, { headers: this.headers });
  }
  savepayoutpostback(data) {
    this.GetHeaderdetails();
    return this.http.put(environment.updateMerchantSettingspayoutpostdataUrl + "?MerchantKeyId=" + data.MerchantKeyId, data
    , { headers: this.headers });
  }
  getMerchantSettingsById(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposMerchantSettingsAppView>(environment.getMerchantSettingsByIdUrl + "?MerchantKeyId=" + data + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers }).pipe(map(response => response),catchError(this.common.handleError));
  }


  AddVirtualAccount(data) {

    let loggedUsername = this.common.getUserName()
    this.token1 = data.CustomerId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post(environment.AddVirtualAccount, data, { headers: this.headers });
  }
  getMerchantServicesAndFees(data, resellerid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<LoginUserModel>(environment.getMerchantFeeServicesListSetupUrl + '?merchantkeyId=' + data + "&resellerId=" + resellerid+"&LoginUserId="+merchantdata.UserId , { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
      
  }


  GetIfsccodedetails(IfscCode, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.GetIfsccodedetails +
        "?IFSCCode=" +
        IfscCode
        + "&MerchantKeyId=" + MerchantKeyId
        + "&LoginUserId="+merchantdata.UserId,
        { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));

  }


  CheckCustomerAccountdetail(Mid, Cid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.CheckCustomerAccountdetail + '?MerchantkeyId=' + Mid + "&Cid=" + Cid+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
      
  }



  InserBankaccountdetails(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.AddPayoutbankdetails, data, { headers: this.headers });
  }


  InsertItem(id, Mid, data) {
    this.GetHeaderdetails();
    return this.http.post(environment.PayOutApprovalDocument + "?MerchantKeyId=" + Mid + "&Id=" + id, data, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));

  }


  GetPayOutAccountdetails(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.GetPayOutAccountdetails +
        "?MerchantKeyId=" +
        MerchantKeyId
        + "&LoginUserId="+merchantdata.UserId
, { headers: this.headers })
.pipe(map(response => response),catchError(this.common.handleError));
  }

  viewPayOutAccountdetails(MerchantKeyId, Id) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.ViewPayOutAccountdetails +
        "?MerchantKeyId=" + MerchantKeyId + "&Id=" + Id+ "&LoginUserId="+merchantdata.UserId
        , { headers: this.headers })


  }
  DeletePayoutSecurity(MerchantKeyId, Id) {
    this.GetHeaderdetails(); 
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.deletePayOutAccountdetails +
        "?Id=" + Id + "&MerchantKeyId=" + MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
        , { headers: this.headers })


  }
  getPaymentReasondetail(MerchantKeyId, OrderAmount) {
    this.GetHeaderdetails();
    return this.http.get<any>(environment.GetPayOutproductcodedatavalidation + '?MerchantkeyId=' + MerchantKeyId + "&Amount=" + OrderAmount, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  GetPayoutSecurityTransactions(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetPayoutSecurityTransactionsUrl + '?MerchantkeyId=' + MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  ResendPayoutCustomerSecurity(Email, MerchantKeyId, TransactionId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.ResendPayoutCustomerSecurityEmailUrl + '?Email=' + Email + '&MerchantKeyId=' + MerchantKeyId + '&TransactionId=' + TransactionId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  ResendPayoutCustomerSecuritysms(contactNo, MerchantKeyId, TransactionId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.ResendPayoutCustomerSecuritysmsUrl + '?contactNo=' + contactNo + '&MerchantKeyId=' + MerchantKeyId + '&TransactionId=' + TransactionId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }


  GetPayoutprocessor(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.GetPayoutprocessorurl +
        "?MerchantKeyId=" +
        MerchantKeyId
        + "&LoginUserId=" + merchantdata.UserId
        , { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));
  }
  getpayoutcontactList(MerchantKeyId, loggedinuseremail) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getpayoutcontactList + "?MerchantKeyId=" + MerchantKeyId + "&UserId=" + loggedinuseremail + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  viewPayOutFilterdataurl(MerchantKeyId, Fromdate1, todate1, Cname, Cid, Name, MobileNo) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.viewPayOutFilterdataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&CompayName=" + Cname
        + "&CustomerId=" + Cid + "&CustomerName=" + Name + "&MobileNumber=" + MobileNo
        + "&LoginUserId=" + merchantdata.UserId
        , { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));
  }

  GetPayOutConatctBeneficiariesList(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.GetPayOutConatctBeneficiariesList + "?MerchantKeyId=" + MerchantKeyId
        + "&LoginUserId="+merchantdata.UserId
, { headers: this.headers })
.pipe(map(response => response),catchError(this.common.handleError));
  }
  viewbenficiarieFilterdataurl(MerchantKeyId, Fromdate1, todate1, AccountNumber, pid, Name, customerkeyid, benificaryname) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.viewbenficiarieFilterdataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&AccountNumber=" + AccountNumber + "&PayOutBeneficiaryKeyId=" + pid + "&BankName=" + Name + "&CustomerkeyId=" + customerkeyid + "&benificaryname=" + benificaryname
        + "&LoginUserId="+merchantdata.UserId
, { headers: this.headers })
.pipe(map(response => response),catchError(this.common.handleError));
  }
  getGetTransactionList(MerchantKeyId, loggedinuseremail) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get<any>(environment.getGetTransactionList + "?MerchantKeyId=" + MerchantKeyId + "&UserId=" + loggedinuseremail + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });

  }
  getpayoutReports(MerchantKeyId, loggedinuseremail) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get<any>(environment.GetPayOutReportsUrl + "?MerchantKeyId=" + MerchantKeyId + "&UserId=" + loggedinuseremail + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });

  }
  getpayoutreportfilter(MerchantKeyId, Fromdate1, todate1, AccountNumber, Tid, Status, Amount, amountcompare, TransactionType, PaymentType, PayOutBeneficiaryKeyId, PayoutCustomerkeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.PayOutReportsFilter + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&AccountNumber=" + AccountNumber
        + "&TransactionId=" + Tid + "&Status=" + Status + "&Amount=" + Amount + "&AmountCheck=" + amountcompare
        + "&TransactionType=" + TransactionType
        + "&PaymentType=" + PaymentType
        + "&PayOutBeneficiaryKeyId=" + PayOutBeneficiaryKeyId
        + "&PayoutCustomerkeyId=" + PayoutCustomerkeyId
        + "&LoginUserId=" + merchantdata.UserId
        , { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));
  }
  viewPayouttransactionFilterdataurl(data) {

    this.GetHeaderdetails();
    // const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    // return this.http
    //   .get<any>(
    //     environment.viewPayouttransactionFilterdataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&AccountNumber=" + AccountNumber
    //     + "&TransactionId=" + Tid + "&BankName=" + BankName + "&Amount=" + Amount + "&AmountCheck=" + amountcompare + "&requestid=" + requestuniqueid + "&PayoutProcessor=" + PayoutProcessor  + "&LoginUserId=" + merchantdata.UserId
    //     , { headers: this.headers })
    //   .map(response => response).catch(this.common.handleError);
      return this.http.post<any>(environment.viewPayouttransactionFilterdataurl,data,{headers:this.headers})
  }
  GetpayoutBatchList(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.GetpayoutBatchList + "?MerchantKeyId=" + MerchantKeyId
        + "&LoginUserId="+merchantdata.UserId
, { headers: this.headers })
.pipe(map(response => response),catchError(this.common.handleError));
  }
  PayOutbatchesFilterdataurl(data) {
    this.GetHeaderdetails();
//     const merchantdata: UserMerchantData = this.common.getUserMerchantData();
//     return this.http
//       .get<any>(
//         environment.PayOutbatchesFilterdataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1
//         + "&PaymentType=" + PaymentType + "&batchid=" + batchid + "&Amount=" + Amount + "&AmountCheck=" + amountcompare
//         + "&LoginUserId="+merchantdata.UserId
// , { headers: this.headers })
//       .map(response => response).catch(this.common.handleError);
      return this.http.post<any>(environment.PayOutbatchesFilterdataurl,data,{headers:this.headers})
  }

  getPayOutBulkUploadFileList(MerchantKeyId, loggedinuseremail) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.getPayOutBulkUploadFileList + "?MerchantKeyId=" + MerchantKeyId + "&UserId=" + loggedinuseremail
        + "&LoginUserId="+merchantdata.UserId
, { headers: this.headers })
.pipe(map(response => response),catchError(this.common.handleError));
  }
  viewPayOutFilterdataurls(MerchantKeyId, Fromdate1, todate1) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.viewPayOutFilterdataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&CompayName=" + ""
        + "&CustomerId=" + "" + "&CustomerName=" + "" + "&MobileNumber=" + ""
        + "&LoginUserId=" + merchantdata.UserId
        , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }
  Getkycdetails(merchantKeyId, accountnumber, ifsccode) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get<any>(environment.Getpayoutkycdetails + "?MerchantKeyId=" + merchantKeyId + "&accountnumber=" + accountnumber + "&ifsccode=" + ifsccode+ "&LoginUserId="+merchantdata.UserId, { headers: this.headers })
  }



  PayoutAccountFilterData(MerchantKeyId, Fromdate1, todate1, number, CustomerId, IFSCCode) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.GetHeaderdetails();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get<any>(environment.PayoutAccountFilterData + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&Accnumber=" + number
      + "&CustomerId=" + CustomerId + "&IFSCCode=" + IFSCCode+ "&LoginUserId="+merchantdata.UserId, { headers: this.headers })

  }

  GetFilteredPayoutSecurityTransactionUrl(MerchantKeyId, fromdate1, todate1, Tid, AccountNumber, IFSCCode) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get<any>(environment.GetFilteredPayoutSecurityTransactionUrl + "?MerchantKeyId=" + MerchantKeyId +
      "&fromdate=" + fromdate1 + "&todate=" + todate1 + "&TransactionId=" + Tid
      + "&Accnumber=" + AccountNumber + "&IFSCCode=" + IFSCCode+ "&LoginUserId="+merchantdata.UserId, { headers: this.headers })
  }

  GetuserRoleBasedPermissions(userId, appName) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get(environment.getUserRoleBasedPermissions + "?UserId=" + userId + "&AppName=" + appName+"&LoginUserId="+merchantdata.UserId+"&MerchantKeyId="+merchantdata.MerchantKeyId, { headers: this.headers })
      
  }
  Getbulkuploaddataurl(data) {
    this.GetHeaderdetails();
    // const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    // return this.http.get(environment.Getbulkuploaddataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&Id=" + FileId
    //   + "&Status=" + Status + "&Amount=" + Amount + "&AmountCheck=" + amountcompare+ "&LoginUserId="+merchantdata.UserId
    //   , { headers: this.headers })
    //   .map(response => response)
    //   .catch(this.common.handleError);
      return this.http.post<any>(environment.Getbulkuploaddataurl,data,{headers:this.headers})
  }
  GetRecentTransactionList(MerchantKeyId, loggedinuseremail) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get(environment.GetRecentTransactionList + "?MerchantKeyId=" + MerchantKeyId + "&UserId=" + loggedinuseremail + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
      
  }
  GetPayoutCreditAllowedAccountsdetails(mid, cid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetPayoutCreditAllowedAccountsdetails + "?MerchantKeyId=" + mid + "&Id=" + cid+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });

  }
  PayoutconfigDefaultAccount(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.PayoutconfigDefaultAccounturl + "?MerchantKeyId=" + merchantdata.MerchantKeyId, data, { headers: this.headers })


  }
  fundtransfermaker(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.fundtransfermakerurl, data, { headers: this.headers })
  }
  payoutfundbanktransfer(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.payoutfundbanktransferurl, data, { headers: this.headers });
  }
  DeclinePayouttransaction(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.Declinepayouttransaction, data, { headers: this.headers });
  }
  GetuserdetailsbyUserid(CreatedBy) {
    this.GetHeaderdetails();
    return this.http
      .get<any>(
        environment.GetuserdetailsbyUserid + "?userId=" + CreatedBy
        , { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));
  }

  Zipcodedetails(Zipcode, Merchantkeyid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.Zipcodedetailsurl + "?Zipcode=" + Zipcode + "&Merchantkeyid=" + Merchantkeyid + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
      
  }


  InitiateOtp(data) {

    this.GetHeaderdetails();
    return this.http.post<any>(environment.InitiateApplicationOtpUrl, data, { headers: this.headers });

  }

  VerifyOtp(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.ValidateApplicationOtpUrl, data, { headers: this.headers });

  }


  GetHeaderdetails() {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    let loggedUsername = this.common.getUserName()
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }

  Getcustomervirtualinfo(MerchantKeyId, loggedinuseremail) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get<any>(environment.GetCustomerVirtualInfourl + "?MerchantKeyId=" + MerchantKeyId + "&UserId=" + loggedinuseremail + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  }
}
